if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }

        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });

        activeMedia?.classList?.add('is-active');

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.firstChild !== activeThumbnail &&
              activeThumbnail.parentElement.prepend(activeThumbnail);
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();

        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }

          const activeMediaRect = activeMedia.getBoundingClientRect();

          if (activeMediaRect.top > -0.5) return;

          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });

        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;

        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));

        thumbnail.querySelector('button').setAttribute('aria-current', true);

        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;

        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);

          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };

        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();

        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');

        if (!this.stickyHeader) return;

        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;

        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => {
          slide.setAttribute('role', 'presentation');
        });
      }
    }
  );
}

// --- Color Variant Image Filter ---
(function () {
  let initialized = false;

  function normalizeColorValue(value) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/\b(?:and)\b|&/g, '-')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function isColorOptionLabel(text) {
    const rawText = String(text || '').trim().toLowerCase();
    const key = normalizeColorValue(rawText).split('-')[0];

    return key === 'color' || key === 'colour' || rawText.includes('颜色');
  }

  function getColorOptionContainer() {
    return Array.from(document.querySelectorAll('.product-form__input, fieldset')).find((container) => {
      const label = container.querySelector('legend, label');
      const labelText = label?.textContent?.replace(/\s+/g, ' ').replace(/:.*$/, '').trim();

      return labelText && isColorOptionLabel(labelText);
    });
  }

  function getCurrentColor() {
    const container = getColorOptionContainer();

    if (container) {
      const checked = container.querySelector('input[type="radio"]:checked');
      if (checked?.value) return checked.value.trim();

      const select = container.querySelector('select');
      if (select?.value) return select.value.trim();

      const selectedValue = container.querySelector('[data-selected-value]');
      if (selectedValue?.textContent) return selectedValue.textContent.trim();
    }

    const colorInput = Array.from(document.querySelectorAll('input[type="radio"], select')).find((element) => {
      return /color|colour/i.test(element.name || '');
    });

    if (colorInput?.tagName === 'SELECT') {
      return colorInput.value.trim();
    }

    if (colorInput?.type === 'radio') {
      return (
        document.querySelector(`input[name="${CSS.escape(colorInput.name)}"]:checked`)?.value?.trim() || ''
      );
    }

    return '';
  }

  function getItemMediaId(item) {
    return item.dataset.mediaId || item.dataset.target || '';
  }

  function getItemAlt(item) {
    return item.querySelector('img')?.getAttribute('alt')?.trim() || '';
  }

  function isUniversalMedia(alt) {
    const key = normalizeColorValue(alt);

    return !key || key === 'all' || key === 'universal' || key === 'default';
  }

  function mediaMatchesColor(alt, color) {
    const altKey = normalizeColorValue(alt);
    const colorKey = normalizeColorValue(color);

    return isUniversalMedia(alt) || !colorKey || altKey === colorKey;
  }

  function setItemVisibility(item, visible) {
    item.hidden = !visible;
    item.style.display = visible ? '' : 'none';
  }

  function focusFirstVisibleMedia(gallery) {
    const firstVisibleThumbnail = Array.from(gallery.querySelectorAll('li[data-target]')).find((item) => {
      return !item.hidden && item.style.display !== 'none';
    });

    if (firstVisibleThumbnail) {
      firstVisibleThumbnail.querySelector('button')?.click();
      return;
    }

    const firstVisibleMedia = Array.from(gallery.querySelectorAll('li[data-media-id]')).find((item) => {
      return !item.hidden && item.style.display !== 'none';
    });

    if (!firstVisibleMedia) return;

    gallery.setActiveMedia?.(firstVisibleMedia.dataset.mediaId, false);

    gallery.querySelector('.product__media-list')?.scrollTo({
      left: firstVisibleMedia.offsetLeft,
      behavior: 'smooth',
    });
  }

  function filterMediaByColor(color) {
    const gallery = document.querySelector('media-gallery');
    if (!gallery) return;

    const mediaItems = Array.from(gallery.querySelectorAll('li[data-media-id]'));
    const thumbnailItems = Array.from(gallery.querySelectorAll('li[data-target]'));
    const altByMediaId = new Map();

    mediaItems.forEach((item) => {
      altByMediaId.set(getItemMediaId(item), getItemAlt(item));
    });

    thumbnailItems.forEach((item) => {
      const mediaId = getItemMediaId(item);

      if (!altByMediaId.get(mediaId)) {
        altByMediaId.set(mediaId, getItemAlt(item));
      }
    });

    mediaItems.forEach((item) => {
      const mediaId = getItemMediaId(item);
      const alt = altByMediaId.get(mediaId);

      setItemVisibility(item, mediaMatchesColor(alt, color));
    });

    thumbnailItems.forEach((item) => {
      const mediaId = getItemMediaId(item);
      const alt = altByMediaId.get(mediaId);

      setItemVisibility(item, mediaMatchesColor(alt, color));
    });

    focusFirstVisibleMedia(gallery);
  }

  function applyCurrentColor() {
    const color = getCurrentColor();

    if (!color) return;

    filterMediaByColor(color);
  }

  function handleVariantChange(event) {
    if (!event.target.closest('variant-selects, variant-radios, .product-form__input')) {
      return;
    }

    window.setTimeout(applyCurrentColor, 100);
    window.setTimeout(applyCurrentColor, 300);
  }

  function init() {
    if (initialized) return;

    initialized = true;

    window.setTimeout(applyCurrentColor, 500);
    document.addEventListener('change', handleVariantChange);

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, () => {
        window.setTimeout(applyCurrentColor, 150);
        window.setTimeout(applyCurrentColor, 400);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();